/***
 * 创建人：李珊
 * 时间：2020-12-28
 * 描述：知识库管理：关联用户
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';

@Component({
  selector: 'app-related-user',
  templateUrl: './related-user.component.html',
  styleUrls: ['./related-user.component.css']
})
export class RelatedUserComponent implements OnInit {
  
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  // 知识库名称
  knowledgebaseName:string = '';
  // 组织树数据
  organizeModel = [];
  readonlySelfIds = [];
  initSelectedNodes = [];
  // 选中的组织id
  orgIds:any = [];
  // 当前选中的组织包含的用户列表数据
  userList:any = [];
  constructor(
    private box: SwMassageBoxService,  //消息提示框
    private jwt: SwJwtService,
    private kmsService: KmsService,   //请求服务
    private system: SystemIdService, //写入systemid
  ) { 

  }

  ngOnInit() {
    // 初始化
    this.clickLoca(this.param["selectedData"]);
  }

  // 知识库点击新增 或者 修改
  clickLoca(selectedData: any) {
    // 查询组织结构
    this.locaOrganize();
    // 获取路由参数
    this.knowledgebaseName = selectedData.knowledgebaseName;
    // 获取当前选中的组织id
    this.getRelatedOrg(selectedData.kgDbId);
  }

  // 获取当前知识库已关联的组织数据
  getRelatedOrg(kgDbId){
    this.kmsService.queryByknowledgebaseId(kgDbId).subscribe(
      data => {
        if(data.code == '200'){
          if(data.data){
            this.orgIds = data.data.map(item => item.orgId);
            // 获取选中组织下的所有用户
            this.orgIds.forEach(item => {
              this.voted({key: item});
            })
          }else{
            this.orgIds = [];
          }
          this.initSelectedNodes = this.orgIds;
        }else{
          this.box.waring(data.msg);
        }
      }
    )
  }

  //查询组织结构
  locaOrganize() {
    this.readonlySelfIds = [];
    let param = { "param": { pageSize: 0 }, "entity": {systemId:this.system.getSystemId()} }
    this.kmsService.queryOrganizePageList(param).subscribe(
      data => {
        if (data["code"] == 200) {
          let orgarray = [];
          let res = data["data"]["records"];
          res.forEach(e => {
            if(e.status){
              orgarray.push(e);  //筛选掉已禁用数据
              if(res.filter(item => item.pid == e.id).length > 0){
                this.readonlySelfIds.push(e.id)
              }
            }
          });
          this.organizeModel = orgarray;
        }
      }
    )
  }

  // 切换选中的组织
  handleVotedClick(event){
    if(event.length == 0){
      this.userList = [];
      this.orgIds = [];
    }else{
      this.userList = [];
      this.orgIds = [];
      event.forEach(item => {
        if(this.organizeModel.filter(item1 => item1.pid == item.key).length == 0){
          this.voted(item);
          this.orgIds.push(item.key);
        }
      })
    }
  }
  
  // 选中某个组织
  voted(event){
    // 获取选中组织下的所有用户
    let systemId = this.system.getSystemId();
    let userParams = {
      entity: {
        systemId: systemId
      },
      organizeId: event.key,
      lazy:true,
      param: {
        systemId: systemId, 
        pageNum: 1,
        pageSize: 1000
      }
    }
    this.kmsService.queryUserByOrganizeId(userParams).subscribe(
      data => {
        if(data.code == '200'){
          let res = data.data && data.data.records ? data.data.records : [];
          this.userList = this.userList.concat(res)
        }
      }
    )
  }

  // 保存当前绑定的组织
  onSubmit() {
    let params = {
      knowledgebaseId: this.param.selectedData.kgDbId,
      orgId: this.orgIds.length>0 ? this.orgIds.join(',') : ''
    };
    this.kmsService.saveOrUpdateRelatedUsers(params).subscribe(
      data => {
        if(data.code == '200'){
          //抛出事件 提示 关闭模态框
          this.modal.toggle();
          this.callback.emit();
          this.box.success('操作成功！');
          // 知识库绑定组织后，需要刷新头部的知识库选项
          this.jwt.setToKen('isRefreshKgDbs','true');
        }else{
          this.box.waring(data.msg);
        }
      }
    );
  }
}

